import request from '@/middleware/request'

const getSetting = () => {
  return request({
    url: '/settings',
    method: 'get'
  })
}

const getSettingAll = () => {
  return request({
    url: '/settings/all',
    method: 'get'
  })
}

const updateSetting = data => {
  return request({
    url: '/settings',
    method: 'patch',
    data
  })
}

const getGeneral = () => {
  return request({
    url: '/settings/general',
    method: 'get'
  })
}

const getGroup = group => {
  return request({
    url: `/settings/group/${group}`,
    method: 'get'
  })
}

const getCustomCaller = () => {
  return request({
    url: '/settings/custom_caller',
    method: 'get'
  })
}

export default {
  getSetting,
  getSettingAll,
  updateSetting,
  getGeneral,
  getGroup,
  getCustomCaller
}
